import {Etage} from './etage.model';
import {Piece} from './piece.model';

export class DossierInterventionActiviteAssechementModel {
    id: number;
    etage_id: number;
    piece_id: number;
    material: string;
    standard: string;
    dossier_intervention_id: number;
    surface: string;
    public constructor(init?: Partial<DossierInterventionActiviteAssechementModel>) {
      Object.assign(this, init);
    }
  }
